import {
    DomSanitizer,
    SafeHtml,
} from '@angular/platform-browser';
import { Component, inject, Inject, SecurityContext, ChangeDetectionStrategy } from '@angular/core';
import { NotificationType } from './notification-type.enum';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBar,
    MatSnackBarModule,
    MatSnackBarRef,
} from '@angular/material/snack-bar';
import { FontCommonModule } from '../../modules/font-common.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-notifier-component',
    templateUrl: './notifier.component.html',
    styleUrls: ['./notifier.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatSnackBarModule,
        FontCommonModule,
    ]
})
export class NotifierComponent {
    safeStr: SafeHtml | null;
    snackBarRef = inject(MatSnackBarRef);

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        public snackBar: MatSnackBar,
        private sanitizer: DomSanitizer,
    ) {
        if (this.data.message) {
            // DO NOT CALL bypassSecurityXXXX methods
            this.safeStr = this.sanitizer.sanitize(
                SecurityContext.HTML,
                this.data.message,
            );
        } else {
            this.safeStr = null;
        }
    }

    get title() {
        if (this.data.title !== undefined) {
            return this.data.title;
        }

        switch (this.data.type) {
            case NotificationType.Success:
                return $localize`Success!`;
            case NotificationType.Error:
                return $localize`Error!`;
            case NotificationType.Info:
                return $localize`Info`;
            default:
                return $localize`Success!`;
        }
    }

    get icon() {
        switch (this.data.type) {
            case NotificationType.Success:
                return 'check';
            case NotificationType.Error:
                return 'xmark';
            case NotificationType.Info:
                return 'info';
            default:
                return 'check';
        }
    }
}
